import React, { useEffect, useState, useContext } from 'react';

import { useHistory } from 'react-router-dom';

import BaseComponentFluxoLogin from '../../Components/BaseComponentFluxoLogin';
import { getTokenSensedia } from '../../Utils/RefreshToken';
import { Context } from '../../services/auth';
import { Spinner } from '../../Components/StyledComponent';
import LandingPage from '../../Components/LandingPage';
import { Auth } from 'aws-amplify';
import Cognito from '../../Amplify';
import '../Home/styles.scss';

import { Login } from '../../Components/Login';

const Home = () => {
  const [loading, setLoading] = useState(true);

  const history = useHistory();

  const [showBannerDesligamento, setShowBannerDesligamento] = useState(true);
  const { setAuthenticated } = useContext(Context);

  useEffect(() => {
    loadHome();
  }, []);

  async function loadHome() {
    setLoading(true);
    const token = localStorage.getItem('token');

    const ficarConectado = localStorage.getItem('qwert');
    if (token && (await verificaSeUserEValido()) && ficarConectado) {
      if (token != '[object Object]') {
        try {
          let resultGetTokenSensedia = await getTokenSensedia(token);
          sessionStorage.setItem('idTokenSens', resultGetTokenSensedia);
          setAuthenticated(true);
          history.push('/atualizar-perfil');
        } catch {
          Cognito.signOut();
          history.push('/');
        }
      } else {
        Cognito.signOut();
        history.push('/');
      }
    } else {
      setAuthenticated(false);
    }

    setLoading(false);
  }

  const verificaSeUserEValido = async () => {
    let temp = null;
    try {
      temp = await Auth.currentAuthenticatedUser();
      if (temp) return true;
    } catch (error) {
      return false;
    }
  };

  if (loading)
    return (
      <div style={{ height: '100vh' }} className='centralized'>
        <Spinner />
      </div>
    );

  const handleShowBanner = () => {
    setShowBannerDesligamento(false);
  };

  return (
    <>
      {showBannerDesligamento && (
        <LandingPage handleShowBanner={handleShowBanner} />
      )}

      <div className='centralized-column'>
        <BaseComponentFluxoLogin>
          <Login />
        </BaseComponentFluxoLogin>
      </div>
    </>
  );
};

export default Home;
